import { createFileRoute } from "@tanstack/react-router";

import { MembersTable } from "@/components/MembersTable";

export const Route = createFileRoute(
  "/_authenticated/organisations/$slug/members",
)({
  component: OrganisationMembersPage,
});

function OrganisationMembersPage() {
  const { slug } = Route.useParams();

  return <MembersTable organisationSlug={slug} />;
}
